// extracted by mini-css-extract-plugin
module.exports = {"signUpHeading":"Register_signUpHeading__TX03d"};